import { Card, CardContent } from "@/components/ui/card";
import { RiskBadge } from "@/components/RiskBadge";
import { Warning, ClockCountdown } from "@phosphor-icons/react";

function getResultStyle(lastResult) {
  if (lastResult.type === "blocked") return "bg-[#FF9F0A]/10 border-[#FF9F0A]/40";
  if (lastResult.type === "error") return "bg-[#FF3B30]/10 border-[#FF3B30]/40";
  const status = lastResult.validation?.risk_status;
  if (status === "fraud") return "bg-[#FF3B30]/10 border-[#FF3B30]/40";
  if (status === "suspicious") return "bg-[#FF9F0A]/10 border-[#FF9F0A]/40";
  return "bg-[#32D74B]/10 border-[#32D74B]/40";
}

function BlockedResult({ message }) {
  return (
    <div className="flex items-start gap-3">
      <Warning size={20} weight="bold" className="text-[#FF9F0A] mt-0.5 shrink-0" />
      <div>
        <p className="text-sm font-semibold text-[#FF9F0A] uppercase tracking-wider">Blocked</p>
        <p className="text-sm text-[#A3A3A3] mt-1">{message}</p>
      </div>
    </div>
  );
}

function ErrorResult({ message }) {
  return (
    <div className="flex items-start gap-3">
      <Warning size={20} weight="bold" className="text-[#FF3B30] mt-0.5 shrink-0" />
      <p className="text-sm text-[#FF3B30]">{message}</p>
    </div>
  );
}

function SuccessResult({ validation }) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="font-mono-data text-lg text-white tracking-wider">{validation.car_plate}</span>
        <RiskBadge status={validation.risk_status} score={validation.risk_score} />
      </div>
      <div className="flex items-center gap-4 text-xs text-[#A3A3A3]">
        <span>Room {validation.room_number}</span>
        <span className="flex items-center gap-1">
          <ClockCountdown size={12} />
          Active for 15 min
        </span>
      </div>
      {validation.risk_reasons?.length > 0 && (
        <div className="mt-2 space-y-1">
          {validation.risk_reasons.map((r) => (
            <p key={r} className="text-xs text-[#737373]">- {r}</p>
          ))}
        </div>
      )}
    </div>
  );
}

export function ValidationResult({ lastResult }) {
  if (!lastResult) return null;

  return (
    <Card
      className={`rounded-sm shadow-none animate-slide-up ${getResultStyle(lastResult)}`}
      data-testid="validation-result"
    >
      <CardContent className="p-4">
        {lastResult.type === "blocked" && <BlockedResult message={lastResult.message} />}
        {lastResult.type === "error" && <ErrorResult message={lastResult.message} />}
        {lastResult.type === "success" && lastResult.validation && (
          <SuccessResult validation={lastResult.validation} />
        )}
      </CardContent>
    </Card>
  );
}
